module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_store_badge_ios_50-12f91ed07413dd84e9e859e21a654ecc.png";